import React from "react";
import { EditButton, MessagePreviewWrapper, PreviewText, PreviewTitle } from "./styled";
import { Icon } from "@dspworkplace/ui";
import Tooltip from "../../../../components/Tooltip/tooltip";

const MessagePreview = ({ children, cardData, handleVisible }) => (
    <MessagePreviewWrapper>
        <PreviewTitle>
            <div>Message Preview</div>
            <Tooltip key={cardData.reminderId} content='Edit Message' direction='right'>
                <EditButton
                    Type="button"
                    onClick={() => handleVisible(cardData)}
                >
                    <Icon.EditV2 size="14px" color="none" strokeColor="currentColor" />
                </EditButton>
            </Tooltip>
        </PreviewTitle>
        <PreviewText>{children}</PreviewText>
    </MessagePreviewWrapper>
);

export default MessagePreview;
